import React from 'react';
import { Grid, Typography } from '@mui/material';
import { getSessionsGroups, isSessionEndTimeHidden } from 'utils/transform';
import { formatTimeDuration } from 'utils/format';

const getTimesLabel = (start: any, end: any, sessions: any[], calendarTimezone: string, t: (key: string) => string) => {
  // JPA-8265: `end` was already converted to a Date in calendarHooks, so match it back against the
  // raw sessions (which still carry hide_end_time) via its ISO string.
  const hideEndTime = end && isSessionEndTimeHidden(sessions, end.toISOString());
  const time = start && end && formatTimeDuration(start, hideEndTime ? null : end, calendarTimezone);

  if (Array.isArray(sessions) && sessions.length > 1) {
    return getSessionsGroups(sessions, calendarTimezone).length > 1
      ? t('common:general.multipleDays')
      : t('common:general.multipleTimes');
  }

  return (
    <>
      {time?.split('|')[0]} <span>{time?.split('|')[1]}</span>
    </>
  );
};

export const renderEventContent = (eventInfo: any, t: (key: string) => string) => {
  const { event } = eventInfo;

  const calendarTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const start = new Date(event.start);
  const end = new Date(event.end);

  const isMidnight = end.getHours() === 0 && end.getMinutes() === 0 && end.getSeconds() === 0;
  const isNextDay = end.getDate() !== start.getDate();
  const isLongRange = isNextDay && !isMidnight;

  const cellDateStr = start.toLocaleDateString('en-CA', { timeZone: calendarTimezone }); // 'YYYY-MM-DD'

  const filteredSessions = Array.isArray(event.extendedProps.sessions)
    ? event.extendedProps.sessions.filter((session: any) => {
        const sessionDate = new Date(session.start_at);
        const sessionDateStr = sessionDate.toLocaleDateString('en-CA', { timeZone: calendarTimezone });
        return sessionDateStr === cellDateStr;
      })
    : event.extendedProps.sessions;

  return (
    <Grid container key={event.id} sx={{ pl: 2, pr: 2, cursor: 'pointer' }}>
      {!isLongRange && (
        <Grid item>
          <Typography
            sx={{
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
              lineHeight: 1.2,
            }}
            fontSize={11}
            fontWeight={500}
            color="text.secondary"
          >
            {getTimesLabel(start, end, filteredSessions, calendarTimezone, t)}
          </Typography>
        </Grid>
      )}

      <Grid item xs={12} sx={{ minWidth: 0 }}>
        <Typography
          fontSize={11}
          fontWeight={500}
          sx={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
            lineHeight: 1.2,
          }}
        >
          {event.title}
        </Typography>
      </Grid>
    </Grid>
  );
};
